import * as yup from "yup";
import { User, GroupMember, UserBusinessUnits } from "types";
import getCurrentUser from "lib/auth/pca";

export const groupMembersPayloadMapper = (groupMember: GroupMember[]): GroupMember[] => {
  const currentUser = getCurrentUser();
  return (
    groupMember?.map(
      (group: GroupMember): GroupMember => ({
        groupID: group?.groupID,
        userCreation: group?.userCreation || currentUser,
      })
    ) ?? []
  );
};

export const userBusinessPayloadMapper = (businessUnits: UserBusinessUnits[]): UserBusinessUnits[] => {
  const currentUser = getCurrentUser();
  return (
    businessUnits?.map(
      (businessUnit: UserBusinessUnits): UserBusinessUnits => ({
        businessUnitId: businessUnit?.businessUnitId,
        userCreation: businessUnit?.userCreation || currentUser,
      })
    ) ?? []
  );
};

export const userPayloadMapper = ({ user, values, IsEdition, groupSelected, businessesSelected }: any): User => {
  const currentUser = getCurrentUser();
  const groupMembers = groupMembersPayloadMapper(groupSelected);
  const userBusinessUnits = userBusinessPayloadMapper(businessesSelected);
  const newUser: User = {
    name: values.name,
    eMail: values.email,
    isActive: true,
    userCreation: currentUser,
    groupMembers,
    userBusinessUnits,
  };
  if (IsEdition) {
    newUser.userID = user?.userID;
    newUser.updatedBy = currentUser;
    newUser.userCreation = user?.userCreation;
  }

  return newUser;
};

export const userValidationSchema = yup.object().shape(
  {
    name: yup.string().required("El nombre es requerido"),
    email: yup.string().email("El email no es válido").required("El email es requerido"),
    groupMembers: yup.array().min(1, "Seleccione un grupo"),
    allBusinessSelected: yup.bool(),
    businesses: yup.string().when("allBusinessSelected", {
      is: (data: boolean) => {
        return !data;
      },
      then: yup.string().required("Seleccione una sede"),
      otherwise: yup.string(),
    }),
  },
  [["allBusinessSelected", "businesses"]]
);

export const getGroups = (groups: GroupMember[]) => groups?.map((group: GroupMember) => group.groupName) || [];

export const getBusinessUnit = (businessUnit: UserBusinessUnits[]) =>
  businessUnit?.map((businessUnit: UserBusinessUnits) => businessUnit.businessUnitId) || [];

export const getApiResponse = (response: any, error: any, isCreate?: boolean) => {
  let message: string | null = "Usuario actualizado correctamente";
  if (error) {
    message = error;
  } else if (response?.data === "OK") {
    message = isCreate ? "Usuario creado correctamente" : message;
  }
  return message;
};

export const userChangeStatus = (user: User): User => {
  const currentUser = getCurrentUser();
  return { ...user, isActive: !user.isActive, updatedBy: currentUser };
};
